import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import FitmentIcon from "modules/fitment/fitment-icon/FitmentIcon";
import { renderHTML } from "util/DomHelper";
import { camelCaseToTitleCase } from "util/helper/helper";
import HideIf from "util/HideIf";
import { IFitmentDetail, IFitmentNotes } from "../../api/interfaces/product-api.type";
import styles from "../fitment/product-fitment.module.scss";
import PATFitmentNote from "./PATFitmentNote";

interface IProps {
  fitmentDetail: IFitmentDetail
}
/**
 * https://partsavatar.atlassian.net/wiki/spaces/STOR/pages/907902977/Fitment+Note+Formats
 * @param props
 * @returns
 */
function EPFitmentNote(props: { fitmentNote: IFitmentNotes }) {
  const { fitmentNote } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { c = [], d, y } = fitmentNote;
  return (
    <div>
      <span>{d}</span>
      <ul>
        {c.map((_) => <li key={_}>{_}</li>)}
      </ul>
      {/* no need to show Y, as per manik */}
      {/* <span>{y}</span> */}
    </div>
  );
}

function PLFitmentNote(props: { fitmentNote: IFitmentNotes }) {
  const { fitmentNote } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { notes = "", variables = "" } = fitmentNote;
  return (
    <>
      <li>
        {variables}
      </li>
      <li>
        {notes}
      </li>
    </>
  );
}

function RenderFitmentNotes(props: IProps) {
  const { fitmentDetail } = props;
  const {
    jsonNote, htmlNote, trims,
  } = fitmentDetail;

  if (jsonNote && jsonNote.datasource) {
    // Part Link data scource
    if (jsonNote.datasource === "pl") {
      return (
        <>
          <ul>
            {
              jsonNote.fitmentNotes.map((fitmentNote, index) => <PLFitmentNote key={index} fitmentNote={fitmentNote} />)
            }
          </ul>

        </>
      );
    }

    if (jsonNote.datasource === "ac") {
      return (
        <>
          <ul>
            {
              Object.keys(jsonNote.fitmentNotes.value).map((key) => (
                <HideIf show={key && jsonNote.fitmentNotes.value[key].length > 0}>
                  <div key={key}>
                    <li>
                      {camelCaseToTitleCase(key)}
                      {" "}
                      - &nbsp;
                      {jsonNote.fitmentNotes.value[key].map((fitmentNote, index) => (
                        <>
                          <PAText component="span" fontSize={FONT_SIZE[0]}>
                            {fitmentNote}
                          </PAText>
                          {index !== jsonNote.fitmentNotes.value[key].length - 1 ? ", " : ""}
                        </>
                      ))}
                    </li>
                  </div>
                </HideIf>
              ))
            }
          </ul>

        </>
      );
    }

    if (jsonNote.datasource === "ep") {
      // epicore have 2 cases, engineNotes and fitmentNotes
      if (jsonNote.engineNotes) {
        return jsonNote.engineNotes.map((_, index) => (
          <>
            <div className={styles.engine_description}>
              <FitmentIcon />
              <div className={styles.extended_description_container}>
                <PAText component="span" fontSize={FONT_SIZE[0]}>
                  {_.engine}
                </PAText>
                <RenderFitmentNotes
                  key={index}
                  fitmentDetail={{
                    jsonNote: {
                      datasource: "ep",
                      fitmentNotes: _.fitmentNotes,
                    },
                  }}
                />
              </div>
            </div>
          </>
        ));
      }
      if (jsonNote.fitmentNotes) {
        return (
          <>
            {
              jsonNote.fitmentNotes.map((fitmentNote, index) => <EPFitmentNote key={index} fitmentNote={fitmentNote} />)
            }
          </>
        );
      }
    }

    if (jsonNote.datasource === "pat") {
      const { fitmentNotes } = jsonNote;
      return (
        <ul>
          {fitmentNotes.map((fitmentNote, idx) => <PATFitmentNote key={idx} fitmentNote={fitmentNote} />)}
        </ul>
      );
    }
  }

  if (htmlNote) {
    return (
      <div
        dangerouslySetInnerHTML={renderHTML(htmlNote)}
      />
    );
  }

  // for Wheels And Tires Packages
  if (trims) {
    return (
      <div>
        <ul>
          {trims.map((_) => <li key={_}>{_}</li>)}
        </ul>
      </div>
    );
  }

  return <> </>;
}

export default RenderFitmentNotes;
